<template>
  <div class="container-fluid current-sale-line"
       :class="{
         'new-item': isNewItem,
         'updated-item': isUpdatedItem
       }"
       style="margin: 0; padding: 0;">
    <template>
      <div class="container-fluid current-sale-line" style="margin: 0; padding: 0;">
        <div class="row" @click="$emit('click')">
          <div class="line-description-pane col-7">
            <h6 class="line-description">
              {{ $utils.toPascalCase($utils.cutLength(saleLine.Description.slice(0, 30) + '...', 60)) }}<br>
            </h6>
            <button type="button" style="display: none" data-bs-toggle="modal"
                    :id="`discountCheck-${saleLine.index}-${uuid}`"
                    :data-bs-target="`#discountModal-${saleLine.index}-${uuid}`"></button>
            <div class="modal fade" :id="`discountModal-${saleLine.index}-${uuid}`" tabindex="-1"
                 :aria-labelledby="`discountModal-${saleLine.index}Label-${uuid}`" aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" :id="`discountModal-${saleLine.index}Label-${uuid}`">
                      Apply Discount to {{ $utils.toPascalCase($utils.cutLength(saleLine.Description, 30)) }}
                    </h5>
                    <button type="button" class="btn-close" :id="`closeBTN-${saleLine.index}-${uuid}`"
                            data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <form>
                    <div class="d-flex flex-row p-1 justify-content-evenly mt-2">
                      <label>
                        <input class="form-check-input" type="radio" value="value" v-model="discountType">
                        Value Discount
                      </label>
                      <label>
                        <input class="form-check-input" type="radio" value="percent" v-model="discountType">
                        Percentage Discount
                      </label>
                    </div>
                    <hr class="mx-2"/>
                    <label class="row mx-3 mb-2">
                      Discount Amount
                      <input type="number" class="form-control" v-model="discountAmount">
                    </label>
                  </form>
                  <div class="modal-footer mt-3">
                    <a class="btn btn-secondary" data-bs-dismiss="modal">Close</a>
                    <a class="btn btn-primary" @click="applyDiscount">Save changes</a>
                  </div>
                </div>
              </div>
            </div>
            <h5 class="text-success text-sm " v-if="saleLine.Discount>0">
              {{ `Discount ${$utils.formatMoney(saleLine.Discount)}` }}</h5>

              <h5 class="text-info text-sm " v-if="saleLine.tourismLevy && saleLine.tourismLevy >0">
                {{ `T.L ${$utils.formatMoney(saleLine.tourismLevy * saleLine.Qty)}` }}</h5>

          </div>
          <div class="d-flex flex-column justify-content-between line-prices-pane col-5">
            <div class="price-row">
              <p class="price-label qty">{{ saleLine.Qty }}<span class="line-price"></span></p>
              <p class="price-label unit">{{ $utils.formatMoney(saleLine.Unit, 2, '.', ',', false) }}<span
                  class="line-price"></span></p>
              <p class="price-label total">{{
                  $utils.formatMoney(((saleLine.Unit + saleLine.tourismLevy) * saleLine.Qty) - saleLine.Discount + instructionTotal, 2, '.', ',', false)
                }}<span class="line-price"></span></p>
            </div>
          </div>
        </div>
        <div class="row">
          <ul class="cooking-instruction-list" v-if="hasInstructions">
            <li class="cooking-instruction-list-item" v-for="instruction in instructions">
              {{ instruction.CookingMsg }} <span>{{ instruction.count }} X {{
                $utils.formatMoney(instruction.Price)
              }}</span>
              Total: {{ $utils.formatMoney(instruction.count * instruction.Price) }}
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import CurrentSaleQty from "@/components/point-of-sale/sales/CurrentSaleQty";
import LineSeparator from "@/components/layout/utils/LineSeparator";

export default {
  name: "CurrentSaleLine",
  components: {LineSeparator, CurrentSaleQty},
  data() {
    return {
      discountType: 'value',
      discountAmount: 0.00,
      uuid: generateUUID(),
    }
  },
  props: {
    saleLine: {
      type: Object,
      required: true
    },
    isNewItem: {
      type: Boolean,
      default: false
    },
    isUpdatedItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasInstructions() {
      return (this.saleLine.instructions && this.saleLine.instructions.length > 0)
    },
    instructionTotal() {
      if (!this.saleLine.instructions || this.saleLine.instructions.length === 0) return 0.00;
      let total = this.saleLine.instructions.map(i => i.Price * i.count).reduce((acc, n) => Number(n) + Number(acc))
      if (isNaN(total)) {
        return 0.00;
      }
      return Number(total.toFixed(2))
    },
    instructions() {
      return this.saleLine.instructions.map((int) => {
        int.Price = Number(int.Price.toFixed(2))
        return int;
      });
    }
  },
  methods: {
    voidItem(item) {
      this.$store.commit(`setOverrideDetails`, `Void Line (${item.Description})`)
      this.$store.commit('voidLine', item)
    },
    async discount() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `Discount`)
      if (!isAllowed) return;
      document.getElementById(`discountCheck-${this.saleLine.index}-${this.uuid}`).click();
    },
    applyDiscount() {
      let type = this.discountType;
      let line = Number(this.saleLine.Unit) * Number(this.saleLine.Qty);
      let discount = Number(this.discountAmount);
      if (type === `percent`) discount = (this.discountAmount / 100) * line;
      this.saleLine.Discount = discount;
      this.saleLine.Line = Number(this.saleLine.Line) - discount;
      document.getElementById(`closeBTN-${this.saleLine.index}-${this.uuid}`).click();
    }
  }
}
</script>

<style lang="scss" scoped>
.current-sale-line {

  .row {
    .line-description-pane {
      .line-description {
        font-size: 14px;
        margin: 0;
        line-height: 18px;
        font-weight: 500;
      }
    }

    .line-prices-pane {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .price-label {
        font-size: 12px;
        margin: 0;

        .line-price {
          font-size: 15px;
          font-weight: 700;
        }
      }
    }
  }

  &.new-item {
    background-color: rgba(76, 175, 80, 0.1); // Light green background for new items
    border-left: 4px solid #4CAF50; // Green left border
    transition: background-color 0.3s ease;
  }

  &.updated-item {
    background-color: rgba(255, 152, 0, 0.1); // Light orange background for updated items
    border-left: 4px solid #FF9800; // Orange left border
    transition: background-color 0.3s ease;
  }
}

button {
  background-color: transparent;
}

.cooking-instruction-list {
  list-style: inside;

  .cooking-instruction-list-item {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: #404040;
    display: flex;
    justify-content: space-between;
  }
}

.price-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; /* Create 3 columns */
  gap: 10px; /* Add some space between the columns */
  align-items: center; /* Vertically align content */
}

.text-sm {
  font-size: 12px;
}

#discount-btn {
  padding: 2px;
  border-radius: 5px;
}
</style>
